// ============================================================
// THE COMPANY — Dashboard (main layout)
// ============================================================

import { useCompanyStore } from "../store/useCompanyStore";
import Toolbar from "./Toolbar";

import OrgChart from "./chart/OrgChart";
import SidePanel from "./panel/SidePanel";
import BoardView from "./board/BoardView";

export default function Dashboard() {
  const sidePanelOpen = useCompanyStore((s) => s.sidePanelOpen);
  const boardViewOpen = useCompanyStore((s) => s.boardViewOpen);

  return (
    <div
      className="flex h-screen w-screen flex-col"
      style={{ backgroundColor: "var(--bg-base)" }}
    >
      {/* Toolbar — fixed top */}
      <Toolbar />

      {/* Main content area below toolbar */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left: Org chart area — shrinks when side panel opens */}
        <div className="flex-1 relative overflow-hidden">
          <OrgChart />
        </div>

        {/* Right: Side panel — conditional, fixed width */}
        {sidePanelOpen && (
          <div
            className="h-full shrink-0 overflow-hidden border-l"
            style={{
              width: "420px",
              borderColor: "var(--border-default)",
              backgroundColor: "var(--bg-surface)",
            }}
          >
            <SidePanel />
          </div>
        )}
      </div>

      {/* Board view overlay */}
      {boardViewOpen && <BoardView />}
    </div>
  );
}
